import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/messages')({
  head: () => ({
    meta: [{ title: 'Messages | Tekst' }],
  }),
});
